export default __webpack_public_path__ + "static/media/gallery-8-1.dcae4625.webp";